import { URL_ROOT } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { Text, TextLink, Card, ContentBlock, Stack } from 'braid-design-system';

import translations from 'src/views/pages/NotFoundPage/.vocab';
import PageHeading from 'src/views/shared/PageHeading/PageHeading';

const NotFoundPage = () => {
  const CUSTOMER_SUPPORT_EMAIL = 'customerservice@seek.com.au';
  const CUSTOMER_SUPPORT_EMAIL_SUBJECT = '404 Error';

  const { t } = useTranslations(translations);

  return (
    <main>
      <ContentBlock>
        <PageHeading title="Lost?" align="center" />
        <Card>
          <Stack space="medium">
            <Text component="p" align="center">
              {t('Page not found title')}
            </Text>
            <Text component="p" align="center">
              {t('Try homepage or contact support', {
                HomepageLink: (children) => (
                  <TextLink href={URL_ROOT} weight="weak">
                    {children}
                  </TextLink>
                ),
                SupportLink: (children) => (
                  <TextLink
                    href={`mailto:${CUSTOMER_SUPPORT_EMAIL}?subject=${CUSTOMER_SUPPORT_EMAIL_SUBJECT}`}
                    weight="weak"
                  >
                    {children}
                  </TextLink>
                ),
              })}
            </Text>
          </Stack>
        </Card>
      </ContentBlock>
    </main>
  );
};

export default NotFoundPage;
